import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ palette, spacing, breakpoints }) => ({
  children: {
    gridArea: 'children',
    overflowX: 'hidden',
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: spacing(34),
    gap: spacing(16),
  },
  accordion: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    margin: spacing(40),
    '& .MuiAccordion-root.Mui-expanded': {
      margin: '0px !absolute',
    },
  },
  app: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    overflow: 'auto',
    flex: 1,
    position: 'relative',
    height: '100%',
  },
  loader: {
    display: 'flex',
    width: '100%',
    flex: 1,
    height: 'calc(100vh - 48px)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerEmail: {
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: spacing(20),
    gap: spacing(40),
  },
  button: {
    color: palette.error.main,
    border: `1px solid ${palette.error.main}`,
    padding: spacing(8, 16),
    margin: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    minWidth: spacing(120),

    backgroundColor: 'transparent',
    fontSize: spacing(14),
    borderRadius: '75px',

    '&:not(:disabled):hover': {
      opacity: '0.8',
    },

    '&:disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'visible',
      color: palette.gray[32],
      backgroundColor: palette.gray[4],
    },
  },
  buttonRed: {
    background: 'transparent',
    color: palette.error.main,
    border: `1px solid ${palette.error.main}`,

    '&:not(:disabled):hover': {
      background: palette.error.main,
      color: palette.gray[4],
    },

    '&:disabled': {
      border: `1px solid ${palette.error.main}`,
    },
  },
  buttonFullBlue: {
    background: palette.primary.main,
    color: palette.gray[4],
    border: 'none',

    '&:not(:disabled):hover': {
      background: palette.primary.main,
      opacity: '0.8',
    },

    '&:disabled': {
      border: `1px solid ${palette.primary.main}`,
    },
  },
  buttonBlue: {
    background: 'transparent',
    color: palette.primary.main,
    border: `1px solid ${palette.primary.main}`,

    '&:not(:disabled):hover': {
      background: palette.primary.main,
      color: palette.gray[4],
    },

    '&:disabled': {
      border: `1px solid ${palette.primary.main}`,
    },
  },
  line: {
    width: '100%',
    display: 'flex',
    gap: spacing(30),

    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: spacing(30),
    },
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(10),
    width: '100%',
  },
  select: {
    width: '100%',
    margin: 0,
    height: '100% !important',
    marginTop: spacing(-15),

    '& .MuiFormLabel-root': {
      fontSize: `${spacing(16)} !important`,
      color: palette.gray[64],
    },

    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  },
  label: {
    color: palette.gray[64],
    fontSize: spacing(12),
  },
  errorMessage: {
    color: `${palette.error.main} !important`,
    margin: 0,
    fontFamily: 'Roboto',
    fontSize: spacing(10.5),
    height: spacing(14),
    display: 'flex !important',
    marginTop: -10,
  },
}))
